import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'

class ContinuousPlugin {
  constructor ($, $container, options, playback, ui) {
    this.$ = $
    this.$container = $container
    this.options = options
    this.playback = playback
    this.ui = ui

    if (typeof global.vhuyaPlayerNextVideo === 'object') {
      this.info = global.vhuyaPlayerNextVideo
      this.playbackTimeUpdateHandler = this.check.bind(this)
      this.playback.on(PlaybackEvent.TIME_UPDATE, this.playbackTimeUpdateHandler)
    }
  }
  check () {
    var duration = this.playback.getDuration()
    if (!duration) return
    var currentTime = this.playback.getCurrentTime()
    var delta = Math.max(10, duration * 0.1)
    if (currentTime >= duration - delta) {
      this.ui.showContinuous(this.info.title, this.info.url)
      this.playback.removeListener(PlaybackEvent.TIME_UPDATE, this.playbackTimeUpdateHandler)
    }
  }
}

export default ContinuousPlugin
